var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ALT error        ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ALT-error--------",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 545684,
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.16959966,0.271359457 L9.80875013,7.69400021 C9.8672922,7.78766752 9.83881757,7.91105759 9.74515026,7.96959966 C9.71336394,7.98946611 9.67663442,8 9.63915047,8 L0.360849528,8 C0.250392578,8 0.160849528,7.91045695 0.160849528,7.8 C0.160849528,7.76251606 0.171383417,7.72578653 0.191249868,7.69400021 L4.83040034,0.271359457 C4.88894241,0.177692151 5.01233248,0.149217518 5.10599979,0.207759584 C5.13175361,0.223855726 5.15350352,0.245605631 5.16959966,0.271359457 Z",
    id: "Triangle",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00625,2.375 C4.7991375,2.375 4.63125,2.5428875 4.63125,2.75 L4.63125,5.16486875 C4.63125,5.37198125 4.7991375,5.53986875 5.00625,5.53986875 C5.2133625,5.53986875 5.38125,5.37198125 5.38125,5.16486875 L5.38125,2.75 C5.38125,2.5428875 5.2133625,2.375 5.00625,2.375 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    cx: 5.00625,
    cy: 6.50530625,
    r: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.37631e4f.svg";
export { ForwardRef as ReactComponent };